// supEl 组建默认值
export const optionDefault = {
  input: {
    attrs: {
      placeholder: '请输入',
    },
    props: {
      clearable: true,
    },
    defaultValue: '',
  },
  radio: {

  },
  checkbox: {
    defaultValue: [],
  },
  select: {
    attrs: {
      placeholder: '请选择',
    },
    props: {
      clearable: true,
      filterable: true,
    },
    defaultValue: '',
  },
  autocomplete: {
    attrs: {
      placeholder: '请输入',
    },
    props: {
      clearable: true,
    },
  },
  'date-picker': {
    props: {
      clearable: true,
      format: 'yyyy-MM-dd',
      'value-format': 'yyyy-MM-dd HH:mm:ss',
      type: 'daterange',
      'range-separator': '至',
      'start-placeholder': '开始日期',
      'end-placeholder': '结束日期',
      'default-time': ['00:00:00', '23:59:59'],
      placeholder: '请选择日期',
    },
    defaultValue: [],
  },
  'input-number': {
    defaultValue: '',
    props: {
      max: Infinity,
      min: -Infinity,
      step: 1,
    },
  },
}
